import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_discipline } from "../shared/data.service";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

import { Dropdown } from "primeng/dropdown";
import {
	wsDisciplineBasicIncidentStudentDataInfo,
	wsDisciplineBasicIncidentInfractionDataInfo,
	wsDisciplineBasicIncidentPenaltyDataInfo,
	wsDisciplineBasicIncidentStudentDataParm,
	wsDisciplineBasicIncidentCalendarDataParm,
	wsDisciplineBasicIncidentCalendarDataInfo,
	wsDisciplineBasicIncidentAddUpdateParm,
} from "../shared/ws-discipline-modify-info";

@Component({
	selector: "app-root",
	templateUrl: "./disciplineaddeditbasic.component.html",
	styleUrls: ["./disciplineaddeditbasic.component.css"],
	providers: [ConfirmationService],
})
export class DisciplineAddEditBasicComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_discipline,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public PersonID: number = -1;
	public IncidentID: number = -1;
	public SchoolID: number = -1;
	public isAdd: boolean = false;

	public IncidentData: wsDisciplineBasicIncidentStudentDataInfo;

	public lstInfractionItems: wsDisciplineBasicIncidentInfractionDataInfo[] = [];
	public SelectedInfraction: wsDisciplineBasicIncidentInfractionDataInfo = {
		InfractionID: -1,
		InfractionDesc: "",
		SchoolID: -1,
		PenaltyID: -1,
	}; // For HTML to not error on init

	public lstPenaltyItems: wsDisciplineBasicIncidentPenaltyDataInfo[] = [];
	public SelectedPenalty: wsDisciplineBasicIncidentPenaltyDataInfo = {
		PenaltyID: -1,
		PenaltyDesc: "",
		SchoolID: -1,
		isSusp: false,
		MinDurationDayCount: 1,
		MaxDurationDayCount: 1,
		AlertID: -1,
		AlertDesc: "",
		SoundData: "",
	}; // For HTML to not error on init

	public isConfigError: boolean = false;

	public rAdminName: string = "";
	public rStudentID: string = "";
	public rFirstName: string = "";
	public rLastName: string = "";
	public rIncidentDT: Date = null;
	public rContinueAlert: boolean = false;
	public rIsUseDayCount: boolean = false;
	public risSusp: boolean = false;
	public rMinDurationDayCount: number = 1;
	public rMaxDurationDayCount: number = 1;

	public selectedRadioValue: string = "1";

	//	RadioValue1
	public rSuspNbrDays1: number = 1;
	public rStartDate1: Date = null;
	public rEndDate1: Date = null;

	//	RadioValue2
	public rSuspNbrDays2: number = 1;
	public rStartDate2: Date = null;
	public rEndDate2: Date = null;

	//	Sound Player
	public mp3Player: any = new Audio();

	//	Error Messaging
	public ErrorMessage: string = "";

	// Portal Apps
	public ParentPortalSendNotification: boolean = false;
	public StudentPortalSendNotification: boolean = false;
	public StaffPortalSendNotification: boolean = false;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.PersonID = this.dialogConfig.data.PersonID;
		this.IncidentID = this.dialogConfig.data.IncidentID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.isAdd = this.dialogConfig.data.isAdd;

		let parm: wsDisciplineBasicIncidentStudentDataParm = {
			UserID: this.UserID,
			PersonID: this.PersonID,
			IncidentID: this.IncidentID,
			SchoolID: this.SchoolID,
		};

		this.isBusy = true;
		this.dataService.DisciplineBasicIncidentGetStudentData(parm).subscribe((data) => this.DisciplineBasicIncidentGetStudentData_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentGetStudentData_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineBasicIncidentGetStudentData_Complete(data: any) {
		this.IncidentData = data;

		this.lstInfractionItems = this.IncidentData.InfractionItems;
		this.lstPenaltyItems = this.IncidentData.PenaltyItems;

		this.rAdminName = this.IncidentData.AdminName;
		this.rStudentID = this.IncidentData.StudentID;
		this.rFirstName = this.IncidentData.FirstName;
		this.rLastName = this.IncidentData.LastName;
		this.rContinueAlert = this.IncidentData.ContinueAlert;

		this.rIsUseDayCount = this.IncidentData.IsUseDayCount;
		this.rSuspNbrDays1 = this.IncidentData.DayCount;
		this.rSuspNbrDays2 = this.IncidentData.DayCount;

		this.rStartDate1 = null; // Set Later
		this.rEndDate1 = null; // Set Later
		this.rStartDate2 = null; // Set Later
		this.rEndDate2 = null; // Set Later

		if (this.rIsUseDayCount == false) {
			this.selectedRadioValue = "1"; // Date Range
		} else {
			this.selectedRadioValue = "2"; // Day Count
		}

		//
		//	Make Sure At Least 1 Infraction and 1 Penalty Item is Set To Basic Mode
		//
		if (this.lstInfractionItems.length == 0) {
			this.ErrorMessage = "No infractions are configured for Basic Mode. Please configure Basic Mode infractions in School Setup to continue.";
			this.isConfigError = true;
			this.isBusy = false;
			return;
		}

		if (this.lstPenaltyItems.length == 0) {
			// actions
			this.ErrorMessage = "No actions are configured for Basic Mode. Please configure Basic Mode actions in School Setup to continue.";
			this.isConfigError = true;
			this.isBusy = false;
			return;
		}

		// Start / End Date
		if (this.IncidentData.StartDate != null) {
			this.rStartDate1 = new Date(this.IncidentData.StartDate); // Must do new for this to work
			this.rStartDate2 = new Date(this.IncidentData.StartDate); // Must do new for this to work
		}

		if (this.IncidentData.EndDate != null) {
			this.rEndDate1 = new Date(this.IncidentData.EndDate); // Must do new for this to work
			this.rEndDate2 = new Date(this.IncidentData.EndDate); // Must do new for this to work
		}

		// SET IncidentDT
		if (this.IncidentData.IncidentDT == null) {
			this.rIncidentDT = null;
		} else {
			this.rIncidentDT = new Date(this.IncidentData.IncidentDT); // Must do new for this to work
		}

		//
		//	Select Default Infraction
		//
		this.SelectedInfraction = this.lstInfractionItems[0];

		this.lstInfractionItems.forEach((item) => {
			if (item.InfractionID == this.IncidentData.InfractionID) {
				this.SelectedInfraction = item;
			}
		});

		//
		//	Select Default Penalty
		//
		this.SelectedPenalty = this.lstPenaltyItems[0];

		this.lstPenaltyItems.forEach((item) => {
			if (item.PenaltyID == this.IncidentData.PenaltyID) {
				this.SelectedPenalty = item;
			}
		});

		this.risSusp = this.SelectedPenalty.isSusp;
		this.rMinDurationDayCount = this.SelectedPenalty.MinDurationDayCount;
		this.rMaxDurationDayCount = this.SelectedPenalty.MaxDurationDayCount;

		this.ParentPortalSendNotification = this.IncidentData.ParentPortalSendNotification;
		this.StudentPortalSendNotification = this.IncidentData.StudentPortalSendNotification;
		this.StaffPortalSendNotification = this.IncidentData.StaffPortalSendNotification;

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onInfractionChange
	//
	//-----------------------------------------------------------------------------------------------------
	onInfractionChange(e: any) {
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		//
		//	Select Default Penalty
		//
		this.lstPenaltyItems.forEach((item) => {
			if (item.PenaltyID == this.SelectedInfraction.PenaltyID) {
				this.SelectedPenalty = item;
			}
		});

		this.risSusp = this.SelectedPenalty.isSusp;
		this.rMinDurationDayCount = this.SelectedPenalty.MinDurationDayCount;
		this.rMaxDurationDayCount = this.SelectedPenalty.MaxDurationDayCount;

		if (this.SelectedPenalty.AlertID > 0) {
			this.rContinueAlert = true;
		} else {
			this.rContinueAlert = false;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPenaltyChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPenaltyChange(e: any) {
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		this.risSusp = this.SelectedPenalty.isSusp;
		this.rMinDurationDayCount = this.SelectedPenalty.MinDurationDayCount;
		this.rMaxDurationDayCount = this.SelectedPenalty.MaxDurationDayCount;

		if (this.SelectedPenalty.AlertID > 0) {
			this.rContinueAlert = true;
		} else {
			this.rContinueAlert = false;
		}

		if (this.risSusp == true) {
			this.onRadioChange();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPlay
	//
	//-----------------------------------------------------------------------------------------------------
	onPlay() {
		if (this.SelectedPenalty.SoundData.length > 0) {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedPenalty.SoundData);
			this.mp3Player.play();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStop
	//
	//-----------------------------------------------------------------------------------------------------
	onStop() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRadioChange
	//
	//-----------------------------------------------------------------------------------------------------
	onRadioChange() {
		if (this.selectedRadioValue == "1") {
			this.ValidateOption1Change();
		} else {
			this.ValidateOption2Change();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDate1Change
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDate1Change(val) {
		this.rStartDate1 = val;
		this.ValidateOption1Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDate1Change
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDate1Change(val) {
		this.rEndDate1 = val;
		this.ValidateOption1Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ValidateOption1Change	(Date Range)
	//
	//-----------------------------------------------------------------------------------------------------
	ValidateOption1Change() {
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		if (this.rStartDate1 != null) {
			if (this.rStartDate1.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		if (this.rEndDate1 != null) {
			if (this.rEndDate1.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid End Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		if (this.rStartDate1 > this.rEndDate1) {
			this.ErrorMessage = "Start Date cannot be greater than End Date";
			return;
		}

		let parm: wsDisciplineBasicIncidentCalendarDataParm = {
			SchoolID: this.SchoolID,
			StartDate: this.rStartDate1,
			EndDate: this.rEndDate1,
			IsUseDayCount: false,
			DayCount: -1,
		};

		this.isBusy = true;
		this.dataService.DisciplineBasicIncidentGetCalendarData(parm).subscribe((data) => this.DisciplineBasicIncidentGetCalendarData_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentGetCalendarData_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineBasicIncidentGetCalendarData_Complete(data: any) {
		var CalendarData: wsDisciplineBasicIncidentCalendarDataInfo;

		CalendarData = data;

		if (CalendarData.IsUseDayCount == true) {
			this.rEndDate2 = new Date(CalendarData.SuspEndDate); // Must do new for this to work
		} else {
			this.rSuspNbrDays1 = CalendarData.SuspNbrDays;

			if (this.rSuspNbrDays1 < this.rMinDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			}

			if (this.rSuspNbrDays1 > this.rMaxDurationDayCount) {
				this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			}
		}

		if (CalendarData.isCalendarValid == false) {
			this.ErrorMessage = "Open calendar days does not support Suspension Days. First update school calendar.";
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSuspNbrDays2
	//
	//-----------------------------------------------------------------------------------------------------
	onSuspNbrDays2() {
		this.ValidateOption2Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDate2Change
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDate2Change(val) {
		this.rStartDate2 = val;
		this.ValidateOption2Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDate2Change
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDate2Change(val) {
		this.rEndDate2 = val;
		this.ValidateOption2Change();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ValidateOption2Change	(Day Count)
	//
	//-----------------------------------------------------------------------------------------------------
	ValidateOption2Change() {
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		if (isNaN(Number(this.rSuspNbrDays2))) {
			this.ErrorMessage = "Number of days is not a number.";
			return;
		}

		if (Number(this.rSuspNbrDays2 < 1)) {
			this.ErrorMessage = "Number of days must be greater than 0.";
			return;
		}

		if (this.rSuspNbrDays2 < this.rMinDurationDayCount) {
			this.ErrorMessage = "Suspension Days cannot be less than " + this.rMinDurationDayCount.toString() + ".";
			return;
		}

		if (this.rSuspNbrDays2 > this.rMaxDurationDayCount) {
			this.ErrorMessage = "Suspension Days cannot be greater than " + this.rMaxDurationDayCount.toString() + ".";
			return;
		}

		if (this.rStartDate2 != null) {
			if (this.rStartDate2.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Start Date. Date must be greater then 1/1/1753.";
				return;
			}
		}

		let parm: wsDisciplineBasicIncidentCalendarDataParm = {
			SchoolID: this.SchoolID,
			StartDate: this.rStartDate2,
			EndDate: null,
			IsUseDayCount: true,
			DayCount: this.rSuspNbrDays2,
		};

		this.isBusy = true;
		this.dataService.DisciplineBasicIncidentGetCalendarData(parm).subscribe((data) => this.DisciplineBasicIncidentGetCalendarData_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onAddUpdate() {
		//
		//	Validate
		//
		if (this.isConfigError == true) {
			return;
		} else {
			this.ErrorMessage = "";
		}

		if (this.rIncidentDT != null) {
			if (this.rIncidentDT.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Invalid Discipline Date. Date must be greater then 1/1/1753.";
				return;
			}
		} else {
			this.ErrorMessage = "Invalid Discipline Date.";
			return;
		}

		if (this.SelectedInfraction.InfractionID < 1) {
			this.ErrorMessage = "Invalid Infraction.";
			return;
		}

		if (this.SelectedPenalty.PenaltyID < 1) {
			this.ErrorMessage = "Invalid Action.";
			return;
		}

		//
		//	Validate Passed / Do the Update
		//
		var parmIsUseDayCount: boolean = false;
		var parmSuspNbrDays: number = 0;
		var parmStartDate: Date = null;
		var parmEndDate: Date = null;

		if (this.risSusp == true) {
			if (this.selectedRadioValue == "1") {
				parmIsUseDayCount = false;
				parmSuspNbrDays = this.rSuspNbrDays1;
				parmStartDate = this.rStartDate1;
				parmEndDate = this.rEndDate1;
			} else {
				parmIsUseDayCount = true;
				parmSuspNbrDays = this.rSuspNbrDays2;
				parmStartDate = this.rStartDate2;
				parmEndDate = this.rEndDate2;
			}
		}

		if (this.isAdd == true) {
			//
			//	Convert From GMT DateTime to Local DateTime
			//
			let strIncidentDT = new Date(this.rIncidentDT).toLocaleString("en-US");
			let strStartDate = new Date(parmStartDate).toLocaleString("en-US");
			let strEndDate = new Date(parmEndDate).toLocaleString("en-US");

			let parm: wsDisciplineBasicIncidentAddUpdateParm = {
				UserID: this.UserID,
				PersonID: this.PersonID,
				IncidentID: -1,
				IncidentDT: strIncidentDT,
				InfractionID: this.SelectedInfraction.InfractionID,
				PenaltyID: this.SelectedPenalty.PenaltyID,
				ContinueAlert: this.rContinueAlert,
				isSusp: this.risSusp,
				IsUseDayCount: parmIsUseDayCount,
				SuspNbrDays: parmSuspNbrDays,
				StartDate: strStartDate,
				EndDate: strEndDate,
				ParentPortalSendNotification: this.ParentPortalSendNotification,
				StudentPortalSendNotification: this.StudentPortalSendNotification,
				StaffPortalSendNotification: this.StaffPortalSendNotification,
			};

			this.isBusy = true;
			this.dataService.DisciplineBasicIncidentAdd(parm).subscribe((data) => this.DisciplineBasicIncidentAdd_Complete(data));
		} else {
			//
			//	Convert From GMT DateTime to Local DateTime
			//
			let strIncidentDT = new Date(this.rIncidentDT).toLocaleString("en-US");
			let strStartDate = new Date(parmStartDate).toLocaleString("en-US");
			let strEndDate = new Date(parmEndDate).toLocaleString("en-US");

			let parm: wsDisciplineBasicIncidentAddUpdateParm = {
				UserID: this.UserID,
				PersonID: this.PersonID,
				IncidentID: this.IncidentID,
				IncidentDT: strIncidentDT,
				InfractionID: this.SelectedInfraction.InfractionID,
				PenaltyID: this.SelectedPenalty.PenaltyID,
				ContinueAlert: this.rContinueAlert,
				isSusp: this.risSusp,
				IsUseDayCount: parmIsUseDayCount,
				SuspNbrDays: parmSuspNbrDays,
				StartDate: strStartDate,
				EndDate: strEndDate,
				ParentPortalSendNotification: this.ParentPortalSendNotification,
				StudentPortalSendNotification: this.StudentPortalSendNotification,
				StaffPortalSendNotification: this.StaffPortalSendNotification,
			};

			this.isBusy = true;
			this.dataService.DisciplineBasicIncidentUpdate(parm).subscribe((data) => this.DisciplineBasicIncidentUpdate_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineBasicIncidentAdd_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	DisciplineBasicIncidentUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	DisciplineBasicIncidentUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
